<template>
    <v-list-tile>
        <v-list-tile-content>
            <v-list-tile-title>{{ uploadedFile.file.name }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
            <v-icon v-if="uploadedFile.isCopy" color="grey lighten-1">file_copy</v-icon>

            <v-layout v-else-if="uploadedFile.uploading" align-center>
                <span class="mr-3 caption font-weight-medium">{{ progress }}</span>
                <v-progress-circular indeterminate size="24" width="1"></v-progress-circular>
            </v-layout>

            <v-icon v-else-if="uploadedFile.done && uploadedFile.succeed" color="green lighten-1">done</v-icon>

            <v-icon v-else-if="uploadedFile.done && !uploadedFile.succeed" color="orange lighten-1">warning</v-icon>
        </v-list-tile-action>
    </v-list-tile>
</template>

<script>
    export default {
        name: "DocumentDropZoneItem",
        props: {
            uploadedFile: {
                type: Object,
                default: null
            }
        },
        computed: {
            progress: function () {
                if ('progress' in this.uploadedFile) {
                    return this.uploadedFile.progress + '%';
                }

                return '';
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
